/*
 *
 * Recommendations reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_RECOMMENDATIONS_FAILED,
  GET_RECOMMENDATIONS_WATCHER,
  GET_RECOMMENDATIONS_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  recommendations: [],
  dimensions: [],
})

function recommendationsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_RECOMMENDATIONS_WATCHER:
      return state.set("isLoading", true).set("recommendations", [])
    case GET_RECOMMENDATIONS_SUCCESS:
      return state
        .set("isLoading", false)
        .set("recommendations", action.payload.recommendations)
        .set("dimensions", action.payload.dimensions)
    case GET_RECOMMENDATIONS_FAILED:
      return state.set("isLoading", false).set("recommendations", [])
    default:
      return state
  }
}

export default recommendationsReducer
